import { type UNSAFE_any } from '@flecto/types'

export const APP_ENV = process.env['APP_ENV'] ?? 'development'

export const SITE_URL = process.env['SITE_URL'] || process.env['VERCEL_URL']

export const CYPRESS_URL = SITE_URL || 'https://localhost:8888'

export const API_URL = process.env['API_URL']

export const PREFIX_VERSION = process.env['PREFIX_VERSION']

export const SEGMENT_KEY = process.env['SEGMENT_KEY']

export const FLECTO_AUTH_URL = 'https://rnters-fe-auth.vercel.app'
export const FLECTO_LINK_URL =
  process.env['FLECTO_LINK_URL'] || 'https://flec.to'
export const FLECTO_LINK_PUBLIC_URL =
  process.env['NEXT_PUBLIC_FLECTO_LINK_URL'] || 'https://flec.to'
export const FLECTO_SAAS_URL =
  process.env['NEXT_PUBLIC_SAAS_URL'] || 'https://app.flecto.io'

// MICROSOFT CLARITY 
export const MICROSOFT_CLARITY_ID =
  process.env['NEXT_PUBLIC_MICROSOFT_CLARITY_ID'] ?? ''

// AUTH0
export const AUTH0_SECRET = process.env['AUTH0_SECRET'] || ''
export const AUTH0_COOKIE_DOMAIN = process.env['AUTH0_COOKIE_DOMAIN']
export const AUTH0_ISSUER_BASE_URL = process.env['AUTH0_ISSUER_BASE_URL']
export const AUTH0_ISSUER_BASE_BUILDER =
  (process.env['AUTH0_ISSUER_BASE_BUILDER'] ?? 'auth.dev.flecto.io') || ''
export const AUTH0_TENANT_DOMAIN =
  process.env['AUTH0_TENANT_DOMAIN'] || 'rnters-dev.eu.auth0.com'
export const AUTH0_CLIENT_ID =
  process.env['AUTH0_CLIENT_ID'] || '2P2Uc0VdmJmPYZApHruUD3evzYeLF6LL'
export const AUTH0_CONNECTION = 'Username-Password-Authentication'
export const AUTH0_AUDIENCE = process.env['AUTH0_AUDIENCE']
export const AUTH0_SCOPE = 'openid profile email'
export const AUTH0_RESPONSE_TYPE = 'token id_token'
export const AUTH0_RESPONSE_MODE = 'form_post'
export const AUTH0_CLIENT_SECRET = process.env.AUTH0_CLIENT_SECRET
export const FLECTO_STORE_SUFFIX = process.env['SAAS_FLECTO_STORE_SUFFIX']

// GOOGLE
export const GTM_ID = process.env['GTM_ID'] || 'GTM-WB7CPD7'
export const GOOGLE_MAPS_API_KEY =
  process.env['GOOGLE_MAPS_API_KEY'] ||
  'AIzaSyC0H1QwTGaD29L7TAF00XPO_fY0LwgPdTs'

// FACEBOOK
export const FACEBOOK_DOMAIN =
  process.env['FACEBOOK_DOMAIN'] || 'yx07jd84hid4l13d5s37e5262ymye4'

// MANGOPAY
export const MANGOPAY_CLIENT_ID =
  process.env['MANGOPAY_CLIENT_ID'] || 'rnters-staging'
export const MANGOPAY_API_URL =
  process.env['MANGOPAY_API_UR'] || 'https://api.sandbox.mangopay.com'

// SLACK
export const SLACK_WEBHOOK_URL =
  'https://hooks.slack.com/services/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'

// CONSTS
export const DEFAULT_CURRENCY = '€'
export const DEFAULT_LOCALE = 'pt-PT'
export const DEFAULT_LOCATION = {
  latitude: 38.736946,
  longitude: -9.142685,
}
export const DEFAULT_DATE_FORMAT_QUERY_PARAMETER = 'yyyy-MM-dd'
export const DEFAULT_DATE_FORMAT_PRESENTATION = 'd MMM'
export const DEFAULT_SEARCH_PARAMS = {
  q: '',
  order: 'desc',
  offset: '0',
  limit: '24',
  latitude: '',
  longitude: '',
}
export const defaultCenter = {
  lat: DEFAULT_LOCATION.latitude,
  lng: DEFAULT_LOCATION.longitude,
}

export const pois = [
  'attraction',
  'business',
  'government',
  'medical',
  'school',
  'place_of_worship',
]
export const poiStyles = pois.map((poi: string) => {
  return {
    featureType: `poi.${poi}`,
    elementType: 'labels.icon',
    stylers: [{ visibility: 'off' }],
  }
})
export const mapOptions = {
  fullscreenControl: false,
  disableDefaultUI: false,
  zoomControl: false,
  styles: [
    ...poiStyles,
    {
      featureType: 'poi.park',
      elementType: 'labels.icon',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'poi.sports_complex',
      elementType: 'labels.icon',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'transit',
      elementType: 'labels.icon',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'road',
      stylers: [{ saturation: -30 }, { lightness: 30 }],
    },
  ],
}
export const defaultMapZoom = 12

export const DEFAULT_PHONE_COUNTRY =
  process.env['DEFAULT_PHONE_COUNTRY'] || 'PT'

// ITEMS
interface itemAttributes {
  address: {
    city: string
    latitude: number
    longitude: number
  }
  description: string
  in_store: boolean
  price_cents: number
  title: string
  photos: Array<photo>
  price_per_day_cents: number
  distance_to?: {
    distance: number
    unit: string
  }
}

interface photo {
  links: {
    large: string
    medium: string
    thumb: string
    thumb_large: string
  }
}

export interface itemProps {
  attributes: itemAttributes
  links: {
    public_url: string
  }
  id: string
}

export interface itemsProps {
  item: itemProps
  small?: boolean
  style?: UNSAFE_any
}

export interface DateFormatOptions {
  weekday?: 'long' | 'short' | 'narrow' | undefined
  year?: 'numeric' | '2-digit' | undefined
  month?: 'long' | 'short' | 'narrow' | 'numeric' | '2-digit' | undefined
  day?: 'numeric' | '2-digit' | undefined
}
